import { useEffect } from 'react'

const PIXEL_ID = '1284151853554260'
let isInitialized = false

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

function loadPixelScript() {
  if (isInitialized) return
  isInitialized = true

  const f = window as Window & typeof globalThis
  const n: ((...args: unknown[]) => void) & {
    callMethod?: (...args: unknown[]) => void
    queue: unknown[][]
    push: (...args: unknown[]) => void
    loaded: boolean
    version: string
  } = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod(...args)
    } else {
      n.queue.push(args)
    }
  } as typeof n

  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  f.fbq = n
  if (!f._fbq) f._fbq = n

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Apoyo Incondicional',
      content_type: 'product',
      value: 7.77,
      currency: 'USD',
    })
  }
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()
    trackPageView()
  }, [])
}
